// import React from 'react';
// import { useQuery } from '@apollo/client';
// import { defaultFiltersForDates } from 'pages/Dashboard/components/constant';
// import { BIDS_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
// import Loader from 'components/common/Loader';
// import LineChart from '../../../LineChart';

// const ActiveBidsChart = ({ selectedOption }) => {
//   const { data, loading, error } = useQuery(BIDS_DATA, {
//     variables: defaultFiltersForDates(selectedOption),
//     fetchPolicy: 'network-only',
//   });

//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading)
//     return (
//       <div className="linechart-loader">
//         <Loader />
//       </div>
//     );

//   const combinedKeysSet = new Set();
//   let firstLineData = [];
//   let secondLineData = [];

//   if (data?.bidsCountData?.offerBids.length) {
//     firstLineData = data.bidsCountData.offerBids.map((val) => {
//       combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
//       return val.count;
//     });
//   }
//   if (data?.bidsCountData?.demandBids.length) {
//     secondLineData = data.bidsCountData.demandBids.map((val) => {
//       combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
//       return val.count;
//     });
//   }
//   const combinedKeys = Array.from(combinedKeysSet);
//   // console.log('day====', combinedKeys, firstLineData, secondLineData);
//   return (
//     <>
//       {' '}
//       <LineChart
//         combinedKeys={combinedKeys}
//         firstLineData={firstLineData}
//         secondLineData={secondLineData}
//         firstHeading="New Offers"
//         secondHeading="New Demands"
//       />
//     </>
//   );
// };

// export default ActiveBidsChart;

// import React from 'react';
// import { useQuery } from '@apollo/client';
// import { defaultFiltersForDates, formatXAxisLabels } from 'pages/Dashboard/components/constant';
// import { BIDS_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
// import Loader from 'components/common/Loader';
// import LineChart from '../../../LineChart';

// const ActiveBidsChart = ({ selectedOption }) => {
//   const { data, loading, error } = useQuery(BIDS_DATA, {
//     variables: defaultFiltersForDates(selectedOption),
//     fetchPolicy: 'network-only',
//   });

//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading)
//     return (
//       <div className="linechart-loader">
//         <Loader />
//       </div>
//     );

//   let firstLineData = [];
//   let secondLineData = [];

//   const xAxisLabels = formatXAxisLabels(selectedOption);

//   if (data?.bidsCountData?.offerBids?.length) {
//     firstLineData = data.bidsCountData.offerBids.map((val) => val.count);
//   }
//   if (data?.bidsCountData?.demandBids?.length) {
//     secondLineData = data.bidsCountData.demandBids.map((val) => val.count);
//   }

//   while (firstLineData.length < xAxisLabels.length) {
//     firstLineData.push(0);
//   }
//   while (secondLineData.length < xAxisLabels.length) {
//     secondLineData.push(0);
//   }

//   return (
//     <LineChart
//       combinedKeys={xAxisLabels}
//       firstLineData={firstLineData}
//       secondLineData={secondLineData}
//       firstHeading="New Offers"
//       secondHeading="New Demands"
//     />
//   );
// };

// export default ActiveBidsChart;

import React from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import {
  defaultFiltersForDates,
  formatXAxisLabels,
} from 'pages/Dashboard/components/constant';
import { BIDS_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
import PermissionNotice from 'pages/Dashboard/components/PermissionNotice';
import Loader from 'components/common/Loader';
import LineChart from '../../../LineChart';

const ActiveBidsChart = ({ selectedOption, canView = true }) => {
  const { data, loading, error } = useQuery(BIDS_DATA, {
    variables: defaultFiltersForDates(selectedOption),
    fetchPolicy: 'network-only',
    skip: !canView,
  });

  if (!canView) {
    return (
      <PermissionNotice message="You do not have permission to view Bids chart." />
    );
  }

  if (error) return `There is an error on this page : ${error.message}`;
  if (loading)
    return (
      <div className="linechart-loader">
        <Loader />
      </div>
    );

  let firstLineData = [];
  let secondLineData = [];

  let xAxisLabels = formatXAxisLabels(selectedOption);

  if (data?.bidsCountData) {
    const { offerBids, demandBids } = data.bidsCountData;

    if (selectedOption === 'this_year') {
      // Year ke liye month-wise mapping
      const offerBidsMap = {};
      const demandBidsMap = {};

      offerBids?.forEach((item) => {
        const month = moment(item.day || item.month).format('MMM');
        offerBidsMap[month] =
          (offerBidsMap[month] || 0) + parseInt(item.count || 0, 10);
      });

      demandBids?.forEach((item) => {
        const month = moment(item.day || item.month).format('MMM');
        demandBidsMap[month] =
          (demandBidsMap[month] || 0) + parseInt(item.count || 0, 10);
      });

      firstLineData = xAxisLabels.map((label) => offerBidsMap[label] || 0);
      secondLineData = xAxisLabels.map((label) => demandBidsMap[label] || 0);
    } else {
      // Day-wise mapping
      const offerBidsMap = {};
      const demandBidsMap = {};

      offerBids?.forEach((item) => {
        const date = moment(item.day).format('D MMM');
        offerBidsMap[date] = parseInt(item.count, 10) || 0;
      });

      demandBids?.forEach((item) => {
        const date = moment(item.day).format('D MMM');
        demandBidsMap[date] = parseInt(item.count, 10) || 0;
      });

      xAxisLabels = xAxisLabels.filter((label) => {
        const date = moment(label, 'D MMM');
        return date.day() !== 0; // 0 = Sunday
      });

      firstLineData = xAxisLabels.map((label) => offerBidsMap[label] || 0);
      secondLineData = xAxisLabels.map((label) => demandBidsMap[label] || 0);
    }
  }

  return (
    <LineChart
      combinedKeys={xAxisLabels}
      firstLineData={firstLineData}
      secondLineData={secondLineData}
      firstHeading="Total offer Bids"
      secondHeading="Total Demand Bids"
    />
  );
};

export default ActiveBidsChart;
